export default "<div class=\"spinner-border\"></div>\n<p>{{ message }}</p>\n";